import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import meShape from 'Workspace/types/me';

import { selectCurrentMe } from 'data/CurrentUser/selectors';
import { featureKeys } from 'services/FeatureFlagService';
import { UserRoles as roles, PermissionTypes } from '../../../constants/enums';
import { compose } from 'redux';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

export const getNavItemsForUser = (currentUser, navItems, getFeatureFlagValue) => {
  if (!currentUser) {
    return [];
  }

  let items = [...navItems];

  items = currentUser.roles.includes(roles.ADMIN) ?
    items.filter((item) => item.key !== PermissionTypes.OWNER.toLocaleLowerCase()) :
    items.filter((item) => item.key !== roles.ADMIN.toLocaleLowerCase());

  if (!getFeatureFlagValue(featureKeys.WORKSPACE_PUBLICATIONS_INTERFACE)) {
    items = items.filter((item) => item.key !== 'publications');
  }

  if (!currentUser.roles.includes(roles.DEVELOPER)) {
    items = items.filter((item) => item.key !== 'plugins');
  }

  return items;
};

class NavigationProvider extends React.Component {
  render() {
    const { render, currentUser, navItems, getFeatureFlagValue } = this.props;
    const userNavItems = getNavItemsForUser(currentUser, navItems, getFeatureFlagValue);

    return render(userNavItems);
  }
}

NavigationProvider.propTypes = {
  render: PropTypes.func,
  currentUser: meShape,
  navItems: PropTypes.array,
};

const mapStateToProps = (state) => ({
  currentUser: selectCurrentMe(state),
});

export default compose(connect(mapStateToProps), enhanceWithFeatureFlagSubscription)(NavigationProvider, [featureKeys.WORKSPACE_PUBLICATIONS_INTERFACE]);
